export default __webpack_public_path__ + "static/media/games.9b1f4c5d.gif";